'use strict';

export default class StandardDictionaryItem {
    id: null | number;
    title: string;
    is_active: boolean;

    constructor(dictionaryItemRawData: StandardDictionaryItem) {
        this.id = dictionaryItemRawData.id;
        this.title = dictionaryItemRawData.title;
        this.is_active = dictionaryItemRawData.is_active ?? true;
    }

    public static findById(id: number | null, dictionary: StandardDictionaryItem[]): StandardDictionaryItem | undefined {
        return dictionary.find((item: StandardDictionaryItem) => {
            return item.id === id;
        });
    }

    public static findByTitle(title: string | null, dictionary: StandardDictionaryItem[]): StandardDictionaryItem | undefined {
        return dictionary.find((item: StandardDictionaryItem) => {
            return item.title === title;
        });
    }
}
